export const Wrapper = ({ children }) => {
  return (
    <div
      className="min-h-screen flex flex-col w-full bg-black rounded-xl"
    >
      {children}
    </div>
  );
};

